import {route} from "../../../../functions/route";

const getDefaultState = () => {
	return {
		loading: true,
		data: {},
		routes: {
			index: "dashboard",
		},
	};
};

const state = getDefaultState();

export default {
	namespaced: true,
	state,
	actions: {
		getData({state, commit}) {
			commit("LOADING", true);
			return new Promise((resolve, reject) => {
				return http().get(route(state.routes.index)).then(response => {
					commit("UPDATE_DATA", response.data);
					commit("LOADING", false);
					resolve();
				});
			});
		},
	},
	mutations: {
		RESET(state) {
			Object.assign(state, getDefaultState());
		},
		LOADING(state, value) {
			state.loading = value;
		},
		UPDATE_DATA(state, data) {
			state.data = data;
		},
	},
};
